module.exports = __webpack_public_path__ + "img/BRAND-04.b15d98c0.jpg";